<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="copyright-page" id="cip">
<p class="crt"><span aria-label="iv" class="page" epub:type="pagebreak" id="piv" role="doc-pagebreak"></span>Copyright © 2022 by Kerry Dolan</p>
<p class="crt">All rights reserved</p>
<p class="crt">Printed in the United States of America</p>
<p class="cipf">ISBN 978-1-61376-914-0 (ebook)</p>
<p class="crtf">Cover design by Sally Nichols</p>
<p class="crt">Cover art: <i>background texture,</i> oil painting by Nuk2013, Shutterstock.com;</p>
<p class="crt"><i>Geometric Waves,</i> by Curly Pat, Shutterstock.com.</p>
<p class="cipf">Library of Congress Cataloging-in-Publication Data</p>
<p class="cip">Names: Dolan, Kerry, author.</p>
<p class="cip">Title: Safe places : stories / Kerry Dolan.</p>
<p class="cip">Description: Amherst : University of Massachusetts Press, [2022] | Series: Juniper prize for fiction</p>
<p class="cip">Identifiers: LCCN 2021054641 (print) | LCCN 2021054642 (ebook) | ISBN</p>
<p class="cip">   9781625346391 (paperback) | ISBN 9781613769133 (ebook) | ISBN</p>
<p class="cip">   9781613769140 (ebook)</p>
<p class="cip">Subjects: LCGFT: Short stories.</p>
<p class="cip">Classification: LCC PS3604.O4266 S24 2022  (print) | LCC PS3604.O4266</p>
<p class="cip">   (ebook) | DDC 813/.6—dc23/eng/20211108</p>
<p class="cip">LC record available at https://lccn.loc.gov/2021054641</p>
<p class="cip">LC ebook record available at https://lccn.loc.gov/2021054642</p>
<p class="cipf">British Library Cataloguing-in-Publication Data</p>
<p class="cip">A catalog record for this book is available from the British Library.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// umaDOLAN0004.vue?1f1d8082